var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5251 21.75L6.5751 18.475L2.8751 17.65L3.2501 13.875L0.725098 11L3.2501 8.125L2.8751 4.35L6.5751 3.525L8.5251 0.25L12.0001 1.725L15.4751 0.25L17.4251 3.525L21.1251 4.35L20.7501 8.125L23.2751 11L20.7501 13.875L21.1251 17.65L17.4251 18.475L15.4751 21.75L12.0001 20.275L8.5251 21.75ZM10.9501 14.625L16.6751 8.9L15.2001 7.4L10.9501 11.625L8.8001 9.525L7.3251 11L10.9501 14.625ZM9.4751 18.85L12.0001 17.775L14.5751 18.85L15.9501 16.475L18.6751 15.85L18.4251 13.075L20.2501 11L18.4251 8.875L18.6751 6.1L15.9501 5.525L14.5251 3.15L12.0001 4.225L9.4251 3.15L8.0501 5.525L5.3251 6.1L5.5751 8.875L3.7501 11L5.5751 13.075L5.3251 15.9L8.0501 16.475L9.4751 18.85Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckStar);
export default __webpack_public_path__ + "static/media/check_star.992439372edd5393c707f23442faa33b.svg";
export { ForwardRef as ReactComponent };